import { IconButton } from '@mui/material'
import { MaterialReactTable } from 'material-react-table'
import { useEffect, useRef, useState } from 'react'
import { FaPerson } from "react-icons/fa6"
import { IoMdAddCircleOutline } from "react-icons/io"
import {MdAssignmentAdd, MdSubscriptions} from "react-icons/md"
import { RiDeleteBin2Line } from 'react-icons/ri'
import { useModifiedMaterialReactTable } from '../misc/modified_react_table'
import { useAllClientSummariesLookup } from '../processes/all_client_summaries_lookup'
import { useAllEmissionCategorySummariesLookup } from '../processes/all_emission_category_summaries_lookup'
import { useAllEmissionFactorSummariesLookup } from '../processes/all_emission_factor_summaries_lookup'
import { useClientAvatarUpload, useClientAvatarUploadState } from '../processes/client_avatar_upload'
import { useClientEmissionAssignment, useClientEmissionAssignmentState } from '../processes/client_emission_assignment'
import { useClientRegistration, useClientRegistrationState } from '../processes/client_registration'
import moment from 'moment'
import {useClientSubscriptionUpdate} from "../processes/client_subscription_update";
import ClientCategoryFactor from "./client_category_factor";

const subscriptionOptions = [
  { id: -1, label: 'Unapproved' },
  { id: 1, label: 'Default' },
  { id: 2, label: 'Active Subscription' },
  { id: 99, label: 'Inactive Subscription' },
];

export default function Clients() {
  const registrationDialog = useRef()
  const [industryDetail, setIndustryDetail] = useState();

  const {
    isPending: clientRegistrationIsInProgress,
  } = useClientRegistrationState()
  const {
    isPending: clientEmissionAssignmentIsInProgress,
  } = useClientEmissionAssignmentState()
  const {
    isPending: clientAvatarUploadIsInProgress,
  } = useClientAvatarUploadState()
  const {
    isPending: clientSubscriptionUpdateIsInProgress,
  } = useClientAvatarUploadState()
  const [
    clientSummaryForEmissionAssignment,
    setClientSummaryForEmissionAssignment,
  ] = useState()
  const [
    clientSummaryForAvatarUpload,
    setclientSummaryForAvatarUpload,
  ] = useState()
  const [
    clientSubscriptionUpdate,
    setClientSubscriptionUpdate,
  ] = useState()

  const {
    data: allClientSummaries,
    isLoading: isLoadingAllUserSummaries,
    isFetching: isFetchingAllUserSummaries,
  } = useAllClientSummariesLookup()
  const allClientSummariesTable = useModifiedMaterialReactTable({
    data: allClientSummaries,
    columns: [
      {
        id: 'id',
        header: 'Id',
        accessorKey: 'clientId',
        Cell: ({ row, cell }) => {
          return <span
            style={{
            }}
          >
            {cell.getValue()}
          </span>
        },
      },
      {
        id: 'name',
        header: 'Name',
        accessorFn: (row) => {
          return row.clientName
        },
        Cell: ({ row, cell }) => {
          return <span
            style={{
              fontWeight: 'bold',
            }}
          >
            {cell.getValue()}
          </span>
        },
      },
      {
        id: 'industry',
        header: 'Industry',
        // use accessorFn so MRT can still search/sort by the visible text
        accessorFn: (row) => row.clientIndustryDetail?.industryName ?? '',
        Cell: ({ row }) => {
          const detail = row.original.clientIndustryDetail;
          const label = detail?.label ?? '—';
          return (
              <button
                  className="tw-btn tw-btn-ghost tw-btn-sm tw-normal-case"
                  onClick={() => detail && setIndustryDetail(detail)}
                  disabled={!detail}
                  title={detail ? 'View industry details' : 'No industry data'}
              >
                {label}
              </button>
          );
        },
      },
      {
        id: 'employees',
        header: 'Employees',
        accessorKey: 'clientEmployees',
      },
      {
        id: 'subscription',
        header: 'Subscription',
        accessorFn: (row) => {
          const option = subscriptionOptions.find(i => i.id === row.clientSubscription)
          return option
              ? option.label
              : 'Unknown Subscription'  // or simply return '' if you prefer
        },
        Cell: ({ row }) => {
          const subscriptionId = row.original.clientSubscription;
          const option = subscriptionOptions.find(i => i.id === subscriptionId);
          const label = option ? option.label : 'Unknown Subscription';
          const isUnapproved = subscriptionId === -1;

          return (
            <span
              style={{
                color: isUnapproved ? '#ef4444' : 'inherit',
                fontWeight: isUnapproved ? 'bold' : 'normal',
              }}
            >
              {label}
            </span>
          );
        },
      },
      {
        id: 'expiration',
        header: 'Expiration',
        accessorFn: (row) => {
          return moment(row.expiration).format('YYYY-MM-DD')
        },
        Cell: ({ row, cell }) => {
          return <span
            style={{
              fontWeight: 'bold',
            }}
          >
            {cell.getValue()}
          </span>
        },
      },
    ],
    getRowId: (row) => {
      return row.clientId
    },
    enablePagination: true,
    state: {
      isLoading: isLoadingAllUserSummaries,
      showProgressBars: isFetchingAllUserSummaries ||
        clientRegistrationIsInProgress ||
        clientAvatarUploadIsInProgress ||
        clientEmissionAssignmentIsInProgress ||
        clientSubscriptionUpdateIsInProgress,
      isSaving: clientRegistrationIsInProgress ||
        clientAvatarUploadIsInProgress ||
        clientEmissionAssignmentIsInProgress ||
          clientSubscriptionUpdateIsInProgress,
    },
    renderTopToolbarCustomActions: () => {
      return <span
        className={[
          'tw-flex-1',
          'tw-flex',
          'tw-items-center',
        ].join(' ')}
      >
        <IconButton
          onClick={() => {
            registrationDialog?.current?.showModal()
          }}
        >
          <IoMdAddCircleOutline className='tw-text-2xl' />
        </IconButton>
      </span>
    },
    // enableRowSelection: false,
    enableRowActions: true,
    renderRowActions: ({ table, row }) => {
      return [
        <IconButton
          key={`row?.id`}
          title="Avatar Upload"
          onClick={() => {
            setclientSummaryForAvatarUpload(row.original)
          }}
        >
          <FaPerson fontSize={'1.5rem'} />
        </IconButton>,
        <IconButton
          key={row?.id}
          title="Emission Assignment"
          onClick={() => {
            setClientSummaryForEmissionAssignment(row.original)
          }}
        >
          <MdAssignmentAdd fontSize={'1.5rem'} />
        </IconButton>,
        <IconButton
            key={row?.id}
            title="Client Subscription"
            onClick={() => {
              setClientSubscriptionUpdate(row.original)
            }}
        >
          <MdSubscriptions fontSize={'1.5rem'} />
        </IconButton>
      ]
    },
  })

  return <div
    className={[
      'tw-flex-1',
      'tw-flex',
      'tw-flex-col',
      'tw-items-stretch',
      'tw-p-7',
    ].join(' ')}
  >
    <MaterialReactTable
      table={allClientSummariesTable}
    />
    <ClientRegistrationDialog
      dialog={registrationDialog}
    />
    <ClientEmissionAssignmentDialog
      clientSummary={clientSummaryForEmissionAssignment}
      onClose={() => setClientSummaryForEmissionAssignment()}
    />
    <ClientAvatarUploadDialog
      clientSummary={clientSummaryForAvatarUpload}
      onClose={() => setclientSummaryForAvatarUpload()}
    />
    <ClientSubscriptionUpdateDialog
        clientSummary={clientSubscriptionUpdate}
        onClose={() => setClientSubscriptionUpdate()}
    />
    <ClientIndustryDetailDialog
        detail={industryDetail}
        onClose={() => setIndustryDetail(undefined)}
    />
  </div>
}

function ClientIndustryDetailDialog({ detail, onClose }) {
  const ref = useRef();

  useEffect(() => {
    if (detail) ref.current?.showModal();
    else ref.current?.close();
  }, [detail]);

  if (!detail) return null;

  const {
    industryName,
    idxName,
    griName,
    sbtiName,
    label,
  } = detail;

  return (
      <dialog
          ref={ref}
          className="tw-modal tw-modal-bottom sm:tw-modal-middle"
          onKeyDown={(e) => { if (e.key === 'Escape') e.stopPropagation(); }}
          onClose={onClose}
      >
        <div className="tw-modal-box tw-border tw-border-[revert] tw-p-0 tw-flex tw-flex-col">
          <div className="tw-font-semibold tw-bg-primary tw-text-primary-content tw-p-4 sm:tw-p-5">
            Industry Detail
          </div>

          <div className="tw-px-4 sm:tw-px-5 tw-py-4 tw-space-y-3">
            <Row label="Industry (TruCarbon)" value={industryName} />
            <Row label="IDX" value={idxName} />
            <Row label="GRI" value={griName} />
            <Row label="SBTi" value={sbtiName} />
            <Row label="Common Label" value={label} />
          </div>

          <button
              type="button"
              className="tw-btn tw-btn-primary tw-w-full"
              onClick={onClose}
          >
            Close
          </button>
        </div>

        <form method="dialog" className="tw-modal-backdrop">
          <button>close</button>
        </form>
      </dialog>
  );
}

// small helper for neat rows
function Row({ label, value }) {
  return (
      <div className="tw-flex tw-items-start tw-gap-3">
        <div className="tw-w-40 tw-font-semibold">{label}</div>
        <div className="tw-flex-1">{value ?? <span className="tw-text-base-content/60">—</span>}</div>
      </div>
  );
}

function ClientSubscriptionUpdateDialog({
                                          clientSummary,
                                          onClose,
                                        }) {
  const [selectedSubscription, setSelectedSubscription] = useState()

  const subscriptionDialog = useRef()
  useEffect(() => {
    if (clientSummary) {
      subscriptionDialog.current.showModal()
      setSelectedSubscription(clientSummary.clientSubscription || 1)
    } else {
      subscriptionDialog.current.close()
    }
  }, [clientSummary])

  const {
    isSuccess: clientSubscriptionUpdateHasSucceeded,
    mutate: clientSubscriptionUpdate,
  } = useClientSubscriptionUpdate()

  useEffect(() => {
    if (clientSubscriptionUpdateHasSucceeded) {
      subscriptionDialog.current.close()
    }
  }, [clientSubscriptionUpdateHasSucceeded])

  return <dialog
      ref={subscriptionDialog}
      className='tw-modal tw-modal-bottom sm:tw-modal-middle'
      onKeyDown={(event) => {
        if (event.key === 'Escape') {
          event.stopPropagation()
        }
      }}
      onClose={event => {
        onClose(event)
      }}
  >
    <div className='tw-modal-box tw-border tw-border-[revert] tw-p-0 tw-flex tw-flex-col'>
      <div
          className={[
            'tw-font-semibold',
            'tw-bg-primary',
            'tw-text-primary-content',
            'tw-p-4',
            'sm:tw-p-5',
            'tw-flex',
            'tw-items-center',
          ].join(' ')}
      >
        Update Client Subscription
      </div>
      <div className={[
        'tw-px-4',
        'sm:tw-px-5',
        'tw-pb-4',
        'sm:tw-pb-5',
        'tw-pt-4',
        'tw-overflow-y-auto',
      ].join(' ')}>
        <div className='tw-form-control tw-w-full'>
          <label className='tw-label'>
            <span className='tw-label-text tw-font-semibold'>
              Select subscription type:
            </span>
          </label>
          <div className='tw-flex tw-flex-col tw-gap-2'>
            {subscriptionOptions.map(option => {
              const isSelected = selectedSubscription === option.id;
              const isUnapproved = option.id === -1;

              return (
                <div
                    key={option.id}
                    className={[
                      'tw-flex',
                      'tw-items-center',
                      'tw-gap-2',
                      'tw-p-3',
                      'tw-border',
                      'tw-rounded-lg',
                      'tw-cursor-pointer',
                      isSelected
                        ? 'tw-border-primary tw-bg-primary tw-bg-opacity-10'
                        : 'tw-border-base-300',
                    ].join(' ')}
                    onClick={() => setSelectedSubscription(option.id)}
                >
                  <input
                      type="radio"
                      className='tw-radio tw-radio-primary'
                      name="subscription-option"
                      checked={isSelected}
                      onChange={() => setSelectedSubscription(option.id)}
                  />
                  <span
                    className={[
                      'tw-ml-2',
                      isUnapproved ? 'tw-text-red-600 tw-font-semibold' : ''
                    ].join(' ')}
                  >
                    {option.label}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <button
          type='button'
          className='tw-btn tw-btn-primary tw-w-full'
          onClick={() => {
            clientSubscriptionUpdate({
              id: clientSummary.clientId,
              clientSubscription: selectedSubscription,
            })
          }}
      >
        Update Subscription
      </button>
    </div>
    <form method='dialog' className='tw-modal-backdrop'>
      <button>close</button>
    </form>
  </dialog>
}

function ClientRegistrationDialog({ dialog }) {
  const {
    isSuccess: clientRegistrationHasSucceeded,
    mutate: clientRegistration,
  } = useClientRegistration()
  useEffect(() => {
    if (clientRegistrationHasSucceeded) {
      dialog.current.close()
    }
  }, [clientRegistrationHasSucceeded, dialog])
  const [clientName, setClientName] = useState('')

  return <dialog
    ref={dialog}
    id='client-registration'
    className='tw-modal tw-modal-bottom sm:tw-modal-middle'
    onKeyDown={(event) => {
      if (event.key === 'Escape') {
        event.stopPropagation()
      }
    }}
    onClose={(event) => {
      setClientName('')
    }}
  >
    <div className='tw-modal-box tw-border tw-border-[revert] tw-p-0 tw-flex tw-flex-col'>
      <div
        className={[
          'tw-font-semibold',
          'tw-bg-primary',
          'tw-text-primary-content',
          'tw-p-4',
          'sm:tw-p-5',
          'tw-flex',
          'tw-items-center',
        ].join(' ')}
      >
        Client Registration
      </div>
      <div className={[
        'tw-px-4',
        'sm:tw-px-5',
        'tw-pb-4',
        'sm:tw-pb-5',
        'tw-overflow-y-auto',
      ].join(' ')}>
        <div className='tw-form-control tw-w-full'>
          <label className='tw-label'>
            <span className='tw-label-text'>
              Name
            </span>
          </label>
          <input
            type='text'
            placeholder='/ Type Here'
            className={[
              'tw-input',
              'tw-input-bordered',
              'tw-input-primary',
              'tw-w-full',
            ].join(' ')}
            value={clientName}
            onChange={(event) => {
              setClientName(event.target.value)
            }}
          />
        </div>
        <div className='tw-pt-4'>
          <button
            type='button'
            className='tw-btn tw-btn-primary tw-w-full'
            onClick={() => {
              clientRegistration({
                clientName,
              })
            }}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
    <form method='dialog' className='tw-modal-backdrop'>
      <button>close</button>
    </form>
  </dialog>
}

function ClientEmissionAssignmentDialog({ clientSummary, onClose }) {
  const ref = useRef();

  useEffect(() => {
    if (clientSummary) {
      ref.current?.showModal();
    } else {
      ref.current?.close();
    }
  }, [clientSummary]);

  if (!clientSummary) return null;

  return (
      <dialog
          ref={ref}
          className="tw-modal tw-modal-bottom sm:tw-modal-middle"
          onKeyDown={(e) => {
            if (e.key === "Escape") e.stopPropagation();
          }}
          onClose={onClose}
      >
        <div
            className={[
              "tw-modal-box",
              "tw-border",
              "tw-border-[revert]",
              "tw-p-0",
              "tw-flex",
              "tw-flex-col",
              "tw-w-[90vw]",
              "sm:tw-w-[80vw]",
              "tw-max-w-7xl",
              "tw-max-h-[90vh]", // prevent overflowing screen
              "tw-h-[90vh]", // ensure consistent height layout
            ].join(" ")}
        >
          {/* Sticky Header */}
          <div className="tw-font-semibold tw-bg-primary tw-text-primary-content tw-p-4 sm:tw-p-5 tw-sticky tw-top-0 tw-z-10">
            Emission Assignment
          </div>

          {/* Scrollable Content */}
          <div className="tw-flex-1 tw-overflow-y-auto tw-px-4 sm:tw-px-5 tw-py-4 tw-space-y-3">
            <ClientCategoryFactor clientId={clientSummary.clientId} />
          </div>

          {/* Fixed Footer (always visible) */}
          <div className="tw-px-4 sm:tw-px-5 tw-py-4 tw-bg-base-100 tw-border-t tw-border-base-300 tw-sticky tw-bottom-0 tw-z-10">
            <button
                type="button"
                className="tw-btn tw-btn-primary tw-w-full"
                onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>

        {/* Backdrop */}
        <form method="dialog" className="tw-modal-backdrop">
          <button>close</button>
        </form>
      </dialog>
  );
}

function ClientAvatarUploadDialog({
  clientSummary,
  onClose,
}) {
  const [file, setFile] = useState()
  const [fileUrl, setFileUrl] = useState()
  useEffect(() => {
    if (!file) {
      setFileUrl()
    } else {
      const url = URL.createObjectURL(file)
      setFileUrl(url)
      return () => URL.revokeObjectURL(url)
    }
  }, [file])

  const fileBox = useRef()
  useEffect(() => {
    if (!file) fileBox.current.value = null
  })

  const avatarUploadDialog = useRef()
  useEffect(() => {
    if (clientSummary) {
      avatarUploadDialog.current.showModal()
    } else {
      avatarUploadDialog.current.close()
    }
  }, [clientSummary])

  const {
    isSuccess: clientAvatarUploadHasSucceeded,
    mutate: clientAvatarUpload,
  } = useClientAvatarUpload()
  useEffect(() => {
    if (clientAvatarUploadHasSucceeded) {
      avatarUploadDialog.current.close()
    }
  }, [clientAvatarUploadHasSucceeded])

  return <dialog
    ref={avatarUploadDialog}
    className='tw-modal tw-modal-bottom sm:tw-modal-middle'
    onKeyDown={(event) => {
      if (event.key === 'Escape') {
        event.stopPropagation()
      }
    }}
    onClose={event => {
      setFile()
      onClose(event)
    }}
  >
    <div className='tw-modal-box tw-border tw-border-[revert] tw-p-0 tw-flex tw-flex-col'>
      <div
        className={[
          'tw-font-semibold',
          'tw-bg-primary',
          'tw-text-primary-content',
          'tw-p-4',
          'sm:tw-p-5',
          'tw-flex',
          'tw-items-center',
        ].join(' ')}
      >
        Client Avatar Upload
      </div>
      <div id='assigned-emissions' className={[
        'tw-px-4',
        'sm:tw-px-5',
        'tw-pb-4',
        'sm:tw-pb-5',
        'tw-overflow-y-auto',
      ].join(' ')}>
        <div className='tw-form-control tw-w-full'>
          <div className='tw-label'>
            {/* <span className='label-text'>
              Avatar
            </span> */}
          </div>
          <div className='tw-flex tw-gap-3 tw-items-center'>
            <div className='tw-flex-1'>
              <input
                ref={fileBox}
                type="file"
                accept='image/*'
                className={[
                  'tw-file-input',
                  'tw-file-input-bordered',
                  'tw-w-full',
                ].join(' ')}

                onChange={(event) => {
                  if (!event.target.files?.length) {
                    setFile()
                  } else {
                    setFile(event.target.files[0])
                  }
                }}
              />
            </div>
            <div className="tw-avatar">
              <div className="tw-w-16 tw-border">
                {clientSummary && <img
                  alt=''
                  src={!fileUrl ? [
                    process.env.REACT_APP_API_URL,
                    '/uploads/client/',
                    clientSummary?.clientImage,
                  ].join('') : fileUrl}
                />}
              </div>
            </div>
          </div>
        </div>
      </div>
      <button
        type='button'
        className='tw-btn tw-btn-primary tw-w-full'
        onClick={() => {
          clientAvatarUpload({
            clientId: clientSummary.clientId,
            avatar: file,
          })
        }}
      >
        Submit
      </button>
    </div>
    <form method='dialog' className='tw-modal-backdrop'>
      <button>close</button>
    </form>
  </dialog>
}

function FilterableSelectDialog({
  idKey,
  nameKey,
  values,
  open,
  onChange,
  onClose,
}) {
  const [search, setSearch] = useState('')
  const searchedValues = values?.filter(value => {
    const name = value[nameKey]
    return name.toLowerCase().includes(search.toLowerCase())
  })
  const dialog = useRef()
  useEffect(() => {
    open && dialog.current.showModal()
  }, [open])
  const [position, setPosition] = useState(0)
  useEffect(() => {
    setPosition(0)
  }, [search])
  const option = useRef()
  useEffect(() => {
    option.current?.scrollIntoView({
      behavior: 'instant',
      block: 'nearest',
    })
  }, [position])

  return <>
    {open && <dialog
      ref={dialog}
      className='tw-modal tw-modal-bottom sm:tw-modal-middle'
      onKeyDown={(event) => {
        event.stopPropagation()
        if (
          event.key === 'ArrowDown' &&
          position + 1 < searchedValues?.length
        ) {
          setPosition(position + 1)
        } else if (
          event.key === 'ArrowUp' &&
          position - 1 > -1
        ) {
          setPosition(position - 1)
        } else if (
          event.key === 'Enter' &&
          searchedValues?.length
        ) {
          setSearch('')
          onChange(searchedValues[position])
        }
      }}
      onClose={(event) => {
        event.stopPropagation()
        setSearch('')
        onClose(event)
      }}
    >
      <div className={[
        'tw-modal-box',
        'tw-border',
        'tw-p-0',
        'tw-flex',
        'tw-flex-col',
        'tw-h-full',
      ].join(' ')}>
        <div className={[
          'tw-px-4',
          'sm:tw-px-5',
          'tw-py-1',
          'sm:tw-py-2',
          'tw-bg-primary',
        ].join(' ')}>
          <input
            type='text'
            placeholder='/ Type Something'
            className={[
              'tw-input',
              'tw-bg-primary',
              'tw-text-primary-content',
              'tw-font-semibold',
              'placeholder:tw-text-primary-content',
              'placeholder:tw-font-semibold',
              'tw-w-full',
              'tw-p-0',
              'focus:tw-outline-none',
            ].join(' ')}
            value={search}
            onChange={(event) => {
              setSearch(event.target.value)
            }}
          />
        </div>
        <div
          id='dialog-body'
          className={[
            'tw-overflow-y-auto',
          ].join(' ')}
        >
          <div className='tw-flex-1 tw-flex tw-flex-col'>
            {searchedValues?.map((value, index) => {
              return <button
                ref={index === position ? option : null}
                className={[
                  'tw-flex-1',
                  'tw-btn',
                  'tw-btn-primary',
                  'tw-no-animation',
                  'tw-transition-none',
                  'tw-border-t-0',
                  'tw-border-x-0',
                  'tw-justify-start',
                  'focus:tw-outline-none',
                  'tw-px-3',
                  'sm:tw-px-4',
                  index === position ? '' : 'tw-btn-outline',
                ].join(' ')}
                key={value[idKey]}
                onClick={() => {
                  setSearch('')
                  onChange(value)
                }}
              >
                {value[nameKey]} ({value[idKey]})
              </button>
            })}
          </div>
        </div>
      </div>
      <form method='dialog' className='tw-modal-backdrop'>
        <button>close</button>
      </form>
    </dialog >}
  </>
}
